module.exports = __webpack_public_path__ + "dc1420a12d64fb303b9ee1ee8bdd214e.png";